/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Generate_ShortInputs */

const en_directory_ai_tools_studio_generate_short = /** @type {(inputs: Directory_Ai_Tools_Studio_Generate_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate`)
};

const zh_directory_ai_tools_studio_generate_short = /** @type {(inputs: Directory_Ai_Tools_Studio_Generate_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成`)
};

/**
* | output |
* | --- |
* | "Generate" |
*
* @param {Directory_Ai_Tools_Studio_Generate_ShortInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_generate_short = /** @type {((inputs?: Directory_Ai_Tools_Studio_Generate_ShortInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Generate_ShortInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_generate_short(inputs)
	return zh_directory_ai_tools_studio_generate_short(inputs)
});
export { directory_ai_tools_studio_generate_short as "directory.ai_tools.studio.generate_short" }